import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { ForgeModule } from "@tylertech/forge-angular";
import { LgdCurrencyComponent } from "./lgdCurrency.component";
import { LgdCurrencyValueAccessor } from "./lgdCurrencyValueAccessor";


@NgModule({
    imports: [CommonModule, ReactiveFormsModule, ForgeModule],
    declarations: [LgdCurrencyComponent, LgdCurrencyValueAccessor],
    exports: [
        ReactiveFormsModule,
        LgdCurrencyComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class LgdCurrencyModule { }
